import React from "react";
import  MultiSelect from "react-multi-select-component";
import 'assets/css/custom.css';

const CustomMultiSelect = props => {

    const filterOptions = (options, filter) => {
        if (!filter) {
          return options;
        }
        const filteredOptions = options.filter((obj => {
            return obj.label.toLowerCase().includes(filter.toLowerCase())
        }))
        return filteredOptions;
      };
    
    return (
        <div>
            <MultiSelect
                options={props.options} 
                value={props.selectChildValue}
                onChange={props.changed}
                filterOptions={filterOptions}
            />
        </div>
    );
}

export default CustomMultiSelect;